import React from 'react';
import PropTypes from 'prop-types';

import { Main } from './styles';

import Header from '~/components/Header';
import Footer from '~/components/Footer';

function MainLayout({ children }) {
    return (
        <>
            <Header />
            <Main>{children}</Main>
            <Footer />
        </>
    );
}

MainLayout.propTypes = {
    children: PropTypes.element.isRequired,
};

export default MainLayout;
